import { render } from "./LoginForm.vue?vue&type=template&id=167e0346"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=167e0346&lang=scss"
script.render = render

export default script